import { patientNamespace } from "@/store/modules/patient";
import { Patient } from "@/store/modules/patient/types";
import { Component, Vue } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import InfusionList from "../shared/InfusionList";

@Component({
  components: { InfusionList }
})
export default class Infusions extends Vue {
  @Getter("current", patientNamespace)
  currentPatient!: Patient;

  @Getter("infusions", patientNamespace)
  infusions!: any;

  @Getter("medList", patientNamespace)
  medList: any;

  @Getter("showMedData", patientNamespace)
  showMedData!: boolean;

  @Action("getMeds", patientNamespace)
  getMeds!: any;

  search: string = "";

  headerConfig = [
    { text: "Medication", value: "display" },
    //{ text: "Rx", value: "rx" },
    { text: "Dose", value: "value", sortable: false },
    { text: "Unit", value: "unit", sortable: false },
    { text: "Time", value: "dt" },
    { text: "Status", value: "status" },
    { text: "Route", value: "route" },
    { text: "Context", value: "context" }
    // { text: "MedOrderID", value: "medOrderID" }
  ];

  get headers() {
    return this.headerConfig;
  }

  get rows() {
    let meds: any[] = [];
    this.medList.forEach((medOrder: any) => {
      medOrder.entries.forEach((med: any) => {
        const arr: any = {
          display: medOrder.display,
          rx: medOrder.rx,

          value: med.value.toString(),
          unit: med.unit,
          dt: med.dt,
          route: medOrder.route,
          context: medOrder.context,
          status: med.status,
          medOrderID: medOrder.ID,
          id: med.dt + "-" + medOrder.ID + "-" + med.medOrder
        };

        meds.push(arr);
      });
    });
    return meds as string[];
  }
  get currentDate() {
    var d = new Date(),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }

  get currentYear() {
    return new Date().getFullYear();
  }

  get summary() {
    const keys = Object.keys(this.infusions);
    return keys.length === 1 && keys[0] === "other";
  }

  get noInfusions() {
    if (!this.currentPatient) {
      return true;
    }
    const infusions = this.currentPatient.body.atoms.infusions;
    return infusions.value === 0;
  }

  get currentRoomSys() {
    return this.$route.params["room"];
  }

  get showMeds() {
    return this.showMedData;
  }

  get medText() {
    return JSON.stringify(this.medList);
  }
  mounted() {
    if (this.showMeds) this.getMeds(this.currentRoomSys);
  }
}
